export default __webpack_public_path__ + "static/media/icon-unit-circle-solid.1224a6e2.svg";